import { bitfToTranslate } from '@common/libs/bitforce/utils/bitf-translate.utils';

export enum EInvestmentLength {
  MONTHS_6 = 'MONTHS_6',
  YEARS_1 = 'YEARS_1',
  YEARS_2 = 'YEARS_2',
  YEARS_3 = 'YEARS_3',
}

bitfToTranslate('COMMON.LABEL.MONTHS_6');
bitfToTranslate('COMMON.LABEL.YEARS_1');
bitfToTranslate('COMMON.LABEL.YEARS_2');
bitfToTranslate('COMMON.LABEL.YEARS_3');
